import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

interface NoteDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (content: string) => void;
  initialContent?: string;
}

const NoteDialog: React.FC<NoteDialogProps> = ({ open, onClose, onSave, initialContent = '' }) => {
  const [content, setContent] = useState(initialContent);

  const handleSave = () => {
    if (content.trim()) {
      onSave(content);
      setContent('');
    }
  };

  const handleClose = () => {
    setContent(initialContent);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Ajouter une note</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Note"
          type="text"
          fullWidth
          multiline
          minRows={3}
          value={content}
          onChange={e => setContent(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={!content.trim()}>
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoteDialog; 